// extracted by mini-css-extract-plugin
export default {"pill":"InlineFeedbackTrigger_pill__q26OW","preview":"InlineFeedbackTrigger_preview__svGEY"};